import { initSubRoutes } from '../../utils/router';

const RoutesPubliqueNousContacter = initSubRoutes({
    route: '/nous-contacter',
    subroutes: {},
    nom: 'Nous contacter',
});

export default RoutesPubliqueNousContacter;
